/* eslint-disable */

export const components = require
  .context('.', true, /vue$/)
  .keys()
  // .filter(path => path.includes('.vue'))
  .map(path => path.replace(/(\.\/)|(\.vue)/g, ''))
  .reduce((acc, key) => ({
    ...acc,
    [key]: require(`./${key}.vue`).default,
  }), {})

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/components/globals/index.js